export default function formatNumberWithCheckDigit(
  number?: string | number | null,
  checkDigit?: string | number | null
) {
  if (number === null || number === undefined || number === '') return ''
  const normalizedNumber = `${number}`.trim().replace(/-+$/, '')
  const normalizedCheckDigit = `${checkDigit ?? ''}`.trim().replace(/^-+/, '')
  if (normalizedNumber === '') return ''
  return normalizedCheckDigit !== ''
    ? `${normalizedNumber}-${normalizedCheckDigit}`
    : normalizedNumber
}
